/** List of all supported ISO 4217 currency codes. */
export const Currencies = [
    /** UAE dirham */ 'AED',
    /** Afghan afghani */ 'AFN',
    /** Albanian lek */ 'ALL',
    /** Armenian dram */ 'AMD',
    /** Netherlands Antillean gulden */ 'ANG',
    /** Angolan kwanza */ 'AOA',
    /** Argentine peso */ 'ARS',
    /** Australian dollar */ 'AUD',
    /** Aruban florin */ 'AWG',
    /** Azerbaijani manat */ 'AZN',
    /** Bosnia and Herzegovina konvertibilna marka */ 'BAM',
    /** Barbadian dollar */ 'BBD',
    /** Bangladeshi taka */ 'BDT',
    /** Bulgarian lev */ 'BGN',
    /** Bahraini dinar */ 'BHD',
    /** Burundi franc */ 'BIF',
    /** Bermudian dollar */ 'BMD',
    /** Brunei dollar */ 'BND',
    /** Bolivian boliviano */ 'BOB',
    /** Brazilian real */ 'BRL',
    /** Bahamian dollar */ 'BSD',
    /** Bhutanese ngultrum */ 'BTN',
    /** Botswana pula */ 'BWP',
    /** Belarusian ruble */ 'BYR',
    /** Belize dollar */ 'BZD',
    /** Canadian dollar */ 'CAD',
    /** Congolese franc */ 'CDF',
    /** Swiss franc */ 'CHF',
    /** Chilean peso */ 'CLP',
    /** Chinese/Yuan renminbi */ 'CNY',
    /** Colombian peso */ 'COP',
    /** Costa Rican colon */ 'CRC',
    /** Cuban peso */ 'CUC',
    /** Cape Verdean escudo */ 'CVE',
    /** Czech koruna */ 'CZK',
    /** Djiboutian franc */ 'DJF',
    /** Danish krone */ 'DKK',
    /** Dominican peso */ 'DOP',
    /** Algerian dinar */ 'DZD',
    /** Estonian kroon */ 'EEK',
    /** Egyptian pound */ 'EGP',
    /** Eritrean nakfa */ 'ERN',
    /** Ethiopian birr */ 'ETB',
    /** European Euro */ 'EUR',
    /** Fijian dollar */ 'FJD',
    /** Falkland Islands pound */ 'FKP',
    /** British pound */ 'GBP',
    /** Georgian lari */ 'GEL',
    /** Ghanaian cedi */ 'GHS',
    /** Gibraltar pound */ 'GIP',
    /** Gambian dalasi */ 'GMD',
    /** Guinean franc */ 'GNF',
    /** Central African CFA franc */ 'GQE',
    /** Guatemalan quetzal */ 'GTQ',
    /** Guyanese dollar */ 'GYD',
    /** Hong Kong dollar */ 'HKD',
    /** Honduran lempira */ 'HNL',
    /** Croatian kuna */ 'HRK',
    /** Haitian gourde */ 'HTG',
    /** Hungarian forint */ 'HUF',
    /** Indonesian rupiah */ 'IDR',
    /** Israeli new sheqel */ 'ILS',
    /** Indian rupee */ 'INR',
    /** Iraqi dinar */ 'IQD',
    /** Iranian rial */ 'IRR',
    /** Icelandic kr\u00f3na */ 'ISK',
    /** Jamaican dollar */ 'JMD',
    /** Jordanian dinar */ 'JOD',
    /** Japanese yen */ 'JPY',
    /** Kenyan shilling */ 'KES',
    /** Kyrgyzstani som */ 'KGS',
    /** Cambodian riel */ 'KHR',
    /** Comorian franc */ 'KMF',
    /** North Korean won */ 'KPW',
    /** South Korean won */ 'KRW',
    /** Kuwaiti dinar */ 'KWD',
    /** Cayman Islands dollar */ 'KYD',
    /** Kazakhstani tenge */ 'KZT',
    /** Lao kip */ 'LAK',
    /** Lebanese lira */ 'LBP',
    /** Sri Lankan rupee */ 'LKR',
    /** Liberian dollar */ 'LRD',
    /** Lesotho loti */ 'LSL',
    /** Lithuanian litas */ 'LTL',
    /** Latvian lats */ 'LVL',
    /** Libyan dinar */ 'LYD',
    /** Moroccan dirham */ 'MAD',
    /** Moldovan leu */ 'MDL',
    /** Malagasy ariary */ 'MGA',
    /** Macedonian denar */ 'MKD',
    /** Myanma kyat */ 'MMK',
    /** Mongolian tugrik */ 'MNT',
    /** Macanese pataca */ 'MOP',
    /** Mauritanian ouguiya */ 'MRO',
    /** Mauritian rupee */ 'MUR',
    /** Maldivian rufiyaa */ 'MVR',
    /** Malawian kwacha */ 'MWK',
    /** Mexican peso */ 'MXN',
    /** Malaysian ringgit */ 'MYR',
    /** Mozambican metical */ 'MZM',
    /** Namibian dollar */ 'NAD',
    /** Nigerian naira */ 'NGN',
    /** Nicaraguan c\u00f3rdoba */ 'NIO',
    /** Norwegian krone */ 'NOK',
    /** Nepalese rupee */ 'NPR',
    /** New Zealand dollar */ 'NZD',
    /** Omani rial */ 'OMR',
    /** Panamanian balboa */ 'PAB',
    /** Peruvian nuevo sol */ 'PEN',
    /** Papua New Guinean kina */ 'PGK',
    /** Philippine peso */ 'PHP',
    /** Pakistani rupee */ 'PKR',
    /** Polish zloty */ 'PLN',
    /** Paraguayan guarani */ 'PYG',
    /** Qatari riyal */ 'QAR',
    /** Romanian leu */ 'RON',
    /** Serbian dinar */ 'RSD',
    /** Russian ruble */ 'RUB',
    /** Saudi riyal */ 'SAR',
    /** Solomon Islands dollar */ 'SBD',
    /** Seychellois rupee */ 'SCR',
    /** Sudanese pound */ 'SDG',
    /** Swedish krona */ 'SEK',
    /** Singapore dollar */ 'SGD',
    /** Saint Helena pound */ 'SHP',
    /** Sierra Leonean leone */ 'SLL',
    /** Somali shilling */ 'SOS',
    /** Surinamese dollar */ 'SRD',
    /** Syrian pound */ 'SYP',
    /** Swazi lilangeni */ 'SZL',
    /** Thai baht */ 'THB',
    /** Tajikistani somoni */ 'TJS',
    /** Turkmen manat */ 'TMT',
    /** Tunisian dinar */ 'TND',
    /** Turkish new lira */ 'TRY',
    /** Trinidad and Tobago dollar */ 'TTD',
    /** New Taiwan dollar */ 'TWD',
    /** Tanzanian shilling */ 'TZS',
    /** Ukrainian hryvnia */ 'UAH',
    /** Ugandan shilling */ 'UGX',
    /** United States dollar */ 'USD',
    /** Uruguayan peso */ 'UYU',
    /** Uzbekistani som */ 'UZS',
    /** Venezuelan bolivar */ 'VEB',
    /** Vietnamese dong */ 'VND',
    /** Vanuatu vatu */ 'VUV',
    /** Samoan tala */ 'WST',
    /** Central African CFA franc */ 'XAF',
    /** East Caribbean dollar */ 'XCD',
    /** Special Drawing Rights */ 'XDR',
    /** West African CFA franc */ 'XOF',
    /** CFP franc */ 'XPF',
    /** Yemeni rial */ 'YER',
    /** South African rand */ 'ZAR',
    /** Zambian kwacha */ 'ZMK',
    /** Zimbabwean dollar */ 'ZWR',
];
/**
 * Polish zloty currency config
 */
export const PLN = defineCurrency({
    code: 'PLN',
    locale: 'pl-PL',
    fractionSymbol: ',',
    fractionDigits: 2,
    symbol: 'zł',
    symbolBefore: false,
});
/**
 * Euro currency config
 */
export const EUR = defineCurrency({
    code: 'EUR',
    locale: 'en-US',
    fractionSymbol: '.',
    fractionDigits: 2,
    symbol: '€',
    symbolBefore: true,
});
/**
 * US dollar currency config
 */
export const USD = defineCurrency({
    code: 'USD',
    locale: 'en-US',
    fractionSymbol: '.',
    fractionDigits: 2,
    symbol: '$',
    symbolBefore: true,
});
/**
 * Currencies map
 */
export const CURRENCIES = {
    /** Polish zloty */
    PLN,
    /** Euro */
    EUR,
    /** United States dollar */
    USD,
};
function defineCurrency(currency) {
    return currency;
}
//# sourceMappingURL=Currency.js.map